

import { useEffect, useState } from 'react';
import './Spinner.scss';

interface Props {
  size?: number;
  containerClassName?: string;
}

export const Spinner = ({size, containerClassName}: Props): JSX.Element => {
  const [spinnerStyle, setSpinnerStyle] = useState({});
  useEffect(() => {
    setSpinnerStyle({
      width: `${size}px`,
      height: `${size}px`,
      fontSize: `${size}px`,
    });
  }, [size]);

  return (
    <div className={`nqt-spinner--container ${containerClassName ? containerClassName : ''}`}>
      <div className="nqt-spinner" style={spinnerStyle}></div>
    </div>
  );
};

export default Spinner;